import { createRoute } from '@tanstack/react-router'
import { OnlyGuest } from 'src/blocks'
import { rootRoute } from 'src/router/root-route'

import AuthLayout from '../AuthLayout'

export const authLayoutOnlyGuestRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => (
    <OnlyGuest>
      <AuthLayout />
    </OnlyGuest>
  ),
  id: 'auth-layout-only-guest'
})
